import moment from 'moment'

export const formatTimestamp = value => {
  if (!value) return null
  // Strict ISO 8601, which is what the platform serialises — a loose parse would
  // fall back to `new Date()` and read arbitrary strings as dates.
  const parsed = moment(value, moment.ISO_8601)
  // The offset is part of the evidence: these strings are pasted into a Natura
  // ticket, where a bare local time is a claim nobody can check.
  return parsed.isValid() ? parsed.format('DD/MM/YYYY HH:mm (Z)') : String(value)
}
